import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const SkincareChallenges = lazyWithPreload(
  () => import('./SkincareChallenges'),
)
